import { Sun, Moon, Monitor, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "@/context/ThemeContext";

import { useTranslation } from "react-i18next";
const OPTIONS = [
  { key: "light", label: "Light", Icon: Sun },
  { key: "dark", label: "Dark", Icon: Moon },
  { key: "system", label: "System", Icon: Monitor },
];

export default function ThemeToggle({ className = "" }) {
  const { t } = useTranslation();
  const { theme, resolved, setTheme } = useTheme();
  const Trigger = resolved === "dark" ? Moon : Sun;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={t("components.themetoggle.toggle_theme")}
        data-testid="theme-toggle-trigger"
        className={
          "inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent/10 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 " +
          className
        }
      >
        <Trigger className="h-4 w-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem]">
        {OPTIONS.map(({ key, label, Icon }) => (
          <DropdownMenuItem
            key={key}
            onClick={() => setTheme(key)}
            data-testid={`theme-option-${key}`}
            className="cursor-pointer"
          >
            <Icon className="mr-2 h-4 w-4" />
            <span className="flex-1">{label}</span>
            {theme === key && <Check className="ml-2 h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
